const isAuthorMode = () => {
  const bodyClassList = document.body.classList;
  return bodyClassList.contains('edit') || bodyClassList.contains('preview');
};
export default isAuthorMode;
